import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { DEFAULT_COMMODITY_CODE } from "../../constants/defaults";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { getServiceTypeCodesOptions } from "../../api/codelist/codeListsSlice";

const CommodityCodeSelect = ({
  name,
  label = "Commodity Code",
  control,
  errors,
  readOnly = false,
  helperText,
  onChange,
}) => {
  const commodityCodesOptions = useSelector(getServiceTypeCodesOptions);
  const getCommodityCodeByCode = (code) => {
    return commodityCodesOptions.find((c) => c.code === code);
  };

  const errorMessage = get(errors, name, {})?.message;
  const combinedHelperText = [helperText, errorMessage]
    .filter(Boolean)
    .join(" * ");

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const selectedItemType =
          getCommodityCodeByCode(field.value) ??
          getCommodityCodeByCode(DEFAULT_COMMODITY_CODE) ??
          null;
        return (
          <Autocomplete
            options={commodityCodesOptions}
            getOptionLabel={(option) => option.code}
            isOptionEqualToValue={(option, value) =>
              option.code === value?.code
            }
            filterOptions={(options, { inputValue }) => {
              const q = inputValue.trim().toLowerCase();
              if (!q) return options;
              return options.filter(
                (o) =>
                  o.code?.toLowerCase().includes(q) ||
                  o.name?.toLowerCase().includes(q),
              );
            }}
            value={selectedItemType}
            onChange={(_, selected) => {
              const newCode = selected?.code || DEFAULT_COMMODITY_CODE;
              field.onChange(newCode);
              onChange?.(newCode);
            }}
            disableClearable={readOnly}
            readOnly={readOnly}
            renderOption={(props, option) => (
              <li {...props} key={option.code}>
                {option.code} - {option.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                sx={{ minWidth: "150px" }}
                error={!!errorMessage}
                helperText={combinedHelperText || ""}
              />
            )}
          />
        );
      }}
    />
  );
};

export default CommodityCodeSelect;
